import types from "./authTypes";

import { USER_KEY, USER_TOKEN } from "../../config/consts";

const initialState = {
	user: JSON.parse(localStorage.getItem(USER_KEY)) || null,
	userToken: JSON.parse(localStorage.getItem(USER_TOKEN)) || null,
	validToken: false,
	// permissions: [],
	loading: false,
	verifyToken: {
		verify: false, 
		used: null, 
		message: null
	}
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = initialState, { type, payload }) => {
	switch (type) {
		case types.TOKEN_VALIDATED:
			if (payload) {
				return { ...state, validToken: true };
			} else {
				localStorage.removeItem(USER_KEY);
				localStorage.removeItem(USER_TOKEN);
				return { ...state, validToken: false, user: null };
			}
		case types.TOKEN_FETCHED:
			localStorage.setItem(USER_TOKEN, JSON.stringify(payload));
			return {
				...state,
				userToken: payload || initialState.userToken
			};
		case types.AUTH_LOADING:
			return {
				...state,
				loading: payload || initialState.loading
			};
		case types.USER_FETCHED:
			localStorage.setItem(USER_KEY, JSON.stringify(payload));
			return {
				...state,
				user: payload || initialState.user,
				loading: false
			}
		case types.LOGOUT:
			localStorage.removeItem(USER_KEY);
			localStorage.removeItem(USER_TOKEN);
			return {
				...state,
				...initialState,
				user: null,
				userToken: false
			}
		case types.RESTORE_PASSWORD_VALIDATED:
			return {
				...state,
				verifyToken: payload || initialState.verifyToken,
				loading: false
			};
		default:
			return state;
	}
};
